/* ZINKE — Rabattcode im Warenkorb, NEU am 24.09.2026 (Theme 7.6)
   Markup und Texte: snippets/zinke-rabattcode.liquid

   Einloesen ueber Shopifys eigenen Rabattlink:
     <Sprachpfad>/discount/CODE?redirect=<Warenkorb>
   Shopify legt den Code in den Warenkorb und schickt zurueck; die Seite
   kommt bereits mit dem reduzierten Preis. Gemessen am 24.09.:
   76,17 € -> 64,75 € mit HERBST15.

   Danach prueft das Skript einmal /cart.js: Steht der Code dort mit
   applicable:false (unbekannt, abgelaufen, passt nicht), wird er per
   /cart/update.js herausgenommen (gueltige Codes bleiben) und der Kunde
   bekommt „gilt nicht“. Vorher (3.1) wurde auf dieser Auswertung auch das
   Einloesen gebaut — und gueltige Codes flogen raus. Jetzt entscheidet
   Shopify selbst, das Skript raeumt nur Ungueltiges weg.

   Alles per Ereignis am document, damit es auch nach dem Neuaufbau des
   Warenkorbs (Mengenaenderung) weiter funktioniert. */
(function () {
  'use strict';
  var KEY_VERSUCH = 'zinkeRabattVersuch';
  var KEY_MELDUNG = 'zinkeRabattMeldung';

  function box() { return document.querySelector('[data-zr]'); }
  function t(name, code) {
    var b = box();
    var s = b ? (b.getAttribute('data-t-' + name) || '') : '';
    return s.replace('%c%', code || '');
  }
  function gleich(a, b) { return String(a).toUpperCase() === String(b).toUpperCase(); }
  function lesen(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function schreiben(k, v) { try { if (v == null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) {} }

  function melden(text, fehler) {
    var m = document.querySelector('[data-zr-meldung]');
    if (!m) return;
    m.textContent = text || '';
    m.hidden = !text;
    m.classList.toggle('is-fehler', !!fehler);
    m.setAttribute('role', fehler ? 'alert' : 'status');
  }

  function einloesen(code) {
    var b = box();
    code = String(code || '').trim();
    var feld = document.querySelector('[data-zr-feld]');
    if (!code) { melden(t('leer'), true); if (feld) feld.focus(); return; }
    if (!b) return;
    var knopf = b.querySelectorAll('[data-zr-einloesen],[data-zr-code]');
    knopf.forEach(function (k) { k.disabled = true; k.setAttribute('aria-busy', 'true'); });
    schreiben(KEY_VERSUCH, code);
    var root = b.getAttribute('data-zr-root') || '';
    var warenkorb = b.getAttribute('data-zr-cart') || '/cart';
    location.href = root + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(warenkorb);
  }

  function nurGueltige(codes) {
    return codes.filter(function (c) { return c.applicable; }).map(function (c) { return c.code; });
  }

  function setzen(liste) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: liste.join(',') })
    }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  }

  function entfernen(code) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var rest = nurGueltige(cart.discount_codes || []).filter(function (c) { return !gleich(c, code); });
        return setzen(rest);
      })
      .then(function () { location.reload(); })
      .catch(function () { melden(t('fehler'), true); });
  }

  /* Nach der Rueckkehr vom Rabattlink: Ergebnis pruefen. */
  function nachpruefen() {
    var alt = lesen(KEY_MELDUNG);
    if (alt) {
      schreiben(KEY_MELDUNG, null);
      var teile = alt.split('|');
      melden(t(teile[0], teile[1]), teile[0] !== 'ok');
      var feld = document.querySelector('[data-zr-feld]');
      if (feld && teile[0] === 'ungueltig') feld.value = teile[1] || '';
    }
    var versuch = lesen(KEY_VERSUCH);
    if (!versuch || !box()) return;
    schreiben(KEY_VERSUCH, null);
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var codes = cart.discount_codes || [];
        var treffer = codes.filter(function (c) { return gleich(c.code, versuch); })[0];
        if (treffer && treffer.applicable) { melden(t('ok', treffer.code), false); return; }
        if (!treffer) { melden(t('ungueltig', versuch), true); return; }
        // Steht drin, greift aber nicht: herausnehmen, Seite neu laden, Meldung danach zeigen.
        return setzen(nurGueltige(codes)).then(function () {
          schreiben(KEY_MELDUNG, 'ungueltig|' + versuch);
          location.reload();
        });
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    if (!box() || !box().contains(e.target)) return;
    var schnell = e.target.closest('[data-zr-code]');
    if (schnell) { e.preventDefault(); einloesen(schnell.getAttribute('data-zr-code')); return; }
    if (e.target.closest('[data-zr-einloesen]')) {
      e.preventDefault();
      var feld = document.querySelector('[data-zr-feld]');
      einloesen(feld ? feld.value : '');
      return;
    }
    var weg = e.target.closest('[data-zr-weg]');
    if (weg) { e.preventDefault(); weg.disabled = true; entfernen(weg.getAttribute('data-zr-weg')); }
  });

  // Enter im Feld darf NICHT das Warenkorbformular (= Zur Kasse) absenden.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.matches('[data-zr-feld]')) return;
    e.preventDefault();
    einloesen(e.target.value);
  });
  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-zr-feld]')) melden('', false);
  });

  // Zurueck-Taste aus dem Checkout: Knoepfe nicht gesperrt stehen lassen.
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-zr] [aria-busy]').forEach(function (k) { k.disabled = false; k.removeAttribute('aria-busy'); });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', nachpruefen);
  else nachpruefen();
})();
